/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_EXIT_TO_APP, NavigationItem, SkipLink } from '@squiz/sds';
import { DXP_ID_MAIN_CONTENT, DXP_ID_MAIN_NAVIGATION } from './ContentIds';
import { DXP_EXTERNAL_LINKS } from './ExternalLinks.constants';
import { ORGANISATION_HOME, PASSWORD_RESET, SIGNUP, TENANTS } from './Screens.constants';
import { CORE_STRINGS } from './Strings.constants';

/**
 * All skip links.
 */
export const DXP_SKIP_LINKS: Array<SkipLink> = [
  {
    key: `Skip to navigation`,
    label: `Skip to navigation`,
    targetId: DXP_ID_MAIN_NAVIGATION,
  },
  {
    key: `Skip to main content`,
    label: `Skip to main content`,
    targetId: DXP_ID_MAIN_CONTENT,
  },
];

/**
 * All navigation items that make up DXP Console core screens.
 */
export const DXP_MENU_CORE_SCREENS: Array<NavigationItem> = [TENANTS, ORGANISATION_HOME, PASSWORD_RESET, SIGNUP];

/**
 * All navigation items that make up the resources collection.
 */
export const DXP_MENU_PLATFORM_RESOURCES: Array<NavigationItem> = [
  {
    action: (): void => {
      window.open(DXP_EXTERNAL_LINKS.userDocumentation, '_blank', 'noopener');
    },
    key: `user-documentation`,
    label: CORE_STRINGS.userDocumentation,
    path: ``,
  },
  {
    action: (): void => {
      window.open(DXP_EXTERNAL_LINKS.helpCenter, '_blank', 'noopener');
    },
    key: `help-center`,
    label: CORE_STRINGS.helpCenter,
    path: ``,
  },
  {
    action: (): void => {
      window.open(DXP_EXTERNAL_LINKS.mySquiz, '_blank', 'noopener');
    },
    key: `my-squiz`,
    label: CORE_STRINGS.mySquiz,
    path: ``,
  },
  {
    action: (): void => {
      window.open(DXP_EXTERNAL_LINKS.customerSuggestions, '_blank', 'noopener');
    },
    key: `customer-suggestions`,
    label: CORE_STRINGS.customerSuggestions,
    path: ``,
  },
];

/**
 * All navigation items that make up the user account menu.
 * These item actions require hooks which cannot be declared in this file.
 * Behaviour will be defined in a hook and included in components that use this menu.
 */
export const DXP_MENU_USER_ACCOUNT: Array<NavigationItem> = [
  {
    key: `my-account`,
    label: CORE_STRINGS.myAccount,
    path: ``,
  },
  {
    icon: ICON_EXIT_TO_APP,
    key: `sign-out`,
    label: CORE_STRINGS.signOut,
    path: ``,
  },
];
